import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {FormComponent} from './form/form.component';
import { PaymentResultComponent } from './payment-result/payment-result.component';
import {OfflineFormComponent} from './offline-form/offline-form.component';

const routes: Routes = [
  { path: 'form/trx/:trx/:type', component: FormComponent },
  { path: 'offlineform/trx/:trx', component: OfflineFormComponent },
  { path: 'form/result', component: PaymentResultComponent},
  { path: '**', redirectTo: 'form/result' },
];

@NgModule({
  exports: [ RouterModule ],
  imports: [ RouterModule.forRoot(routes) ]
})
export class AppRoutingModule { }
